module.exports = __webpack_public_path__ + "img/personal_content.c8b094d5.png";